import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import QuizLeaderboardPage from '../../../pages/Cards/QuizLeaderboardPage';
import QuizLeaderboardMobile from '../../../pages/Mobile/Cards/QuizLeaderboardMobile';

const QuizLeaderboardResponsive: React.FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <QuizLeaderboardMobile /> : <QuizLeaderboardPage />;
};

export default QuizLeaderboardResponsive;
